<script>
import TopbarSignedIn from "../components/TopbarSignedIn.svelte";
import Header from "../components/header/Header.svelte";
import Modals from "../components/Modals.svelte";
import Footer from "../components/Footer.svelte";

let complaint = {
  articlenumber: "108080",
  errand: "166734",
  product: "Spanjolett S1151 (865) L= 388M",
  ammount: "1",
  price: "240",
  sum: "240",
  date: "2020-11-25",
};
</script>

<div class="container" id="wrapper">
  <TopbarSignedIn />
  <Header />
  <div class="complaint-three">
    <div class="row">
      <div class="col-xs-12">
        <div class="row fill-white">
          <div class="col-xs-12">
            <div id="content" class="main-content">
              <!-- contenttop -->
              <div class="row">
                <div class="col-xs-12">
                  <ul class="breadcrumb">
                    <li class="active">Min sida</li>
                    <li>
                      <a href="/shop/IboxServlet?p=IXS850">Reklamationer</a>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="padd">
                <!-- Workflow -->
                <div class="workflow">
                  <ul class="breadcrumb breadcrumb-secondary mt-md">
                    <li><a href="#"><span>1. Ärende</span></a></li>
                    <li><a href="#"><span>2. Rader</span></a></li>
                    <li class="active-step"><span>3. Anmärkningar</span></li>
                    <li><a href="#"><span>4. Leveransadress</span></a></li>
                    <li><a href="#"><span>5. Boka</span></a></li>
                    <li><a href="#"><span>6. Kvitto</span></a></li>
                  </ul>
                </div>

                <div class="row">
                  <div class="col-xs-12 mt-sm">
                    <h2>Ny reklamation / retur</h2>
                  </div>
                </div>

                <div class="border-frame col-md-12">
                  <form
                    class="full cart"
                    action="/shop/IboxServlet"
                    method="post"
                    accept-charset="utf-8"
                    onsubmit="return update()"
                    name="form"
                  >
                    <input type="hidden" name="p" value="IXS855" />
                    <input type="hidden" name="OPT" value="2" />
                    <input type="hidden" name="LAST" value="J" />
                    <input type="hidden" name="LAD1" value="" />
                    <input type="hidden" name="LAD2" value="" />
                    <input type="hidden" name="LAD3" value="" />
                    <input type="hidden" name="LPNR" value="" />
                    <input type="hidden" name="LORT" value="" />

                    <div class="products">
                      <div class="table-responsive">
                        <table class="table table-condensed table-striped">
                          <thead class="table-header-inverse">
                            <tr>
                              <th class="first">Artikel</th>
                              <th>Ärende</th>
                              <th>Benämning</th>
                              <th>Antal</th>
                              <th>Pris</th>
                              <th>Belopp</th>
                              <th width="100">Fakturadatum</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr valign="top" class="odd">
                              <td class="first">{complaint.articlenumber}</td>
                              <td>{complaint.errand}</td>
                              <td><strong>{complaint.product}</strong></td>
                              <td>{complaint.ammount} st</td>
                              <td>{complaint.price} SEK</td>
                              <td>{complaint.sum} SEK</td>
                              <td>{complaint.date}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="form-container">
                      <div data-aid="108080">
                        <!--ORSAK-->
                        <div class="select">
                          <div class="form-group">
                            <label>Orsak</label>
                            <div>
                              <select name="ORSK">
                                <option value="" selected="selected">
                                  -- Välj alternativ --
                                </option>
                                <option value="C">
                                  Fel plock (från vårt lager)
                                </option>
                                <option value="E">Produktreklamation</option>
                                <option value="F">
                                  Retur / Felbeställt / Felregistrering
                                </option>
                                <option value="H">
                                  Transportskada / Saknat gods
                                </option>
                              </select>

                              <label>Övrig information</label>
                              <textarea
                                maxlength="500"
                                rows="5"
                                name="ANM"
                                class="form-control"
                                placeholder="Din text"
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- ANDRA DELEN -->

                    <input type="hidden" name="p" value="IXS855" />
                    <input type="hidden" name="OPT" value="2" />
                    <input type="hidden" name="LAST" value="J" />
                    <input type="hidden" name="LAD1" value="" />
                    <input type="hidden" name="LAD2" value="" />
                    <input type="hidden" name="LAD3" value="" />
                    <input type="hidden" name="LPNR" value="" />
                    <input type="hidden" name="LORT" value="" />

                    <div class="products">
                      <div class="table-responsive">
                        <table class="table table-condensed table-striped">
                          <thead class="table-header-inverse">
                            <tr>
                              <th class="first">Artikel</th>
                              <th>Ärende</th>
                              <th>Benämning</th>
                              <th>Antal</th>
                              <th>Pris</th>
                              <th>Belopp</th>
                              <th width="100">Fakturadatum</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr valign="top" class="odd">
                              <td class="first">{complaint.articlenumber}</td>
                              <td>{complaint.errand}</td>
                              <td><strong>{complaint.product}</strong></td>
                              <td>{complaint.ammount} st</td>
                              <td>{complaint.price} SEK</td>
                              <td>{complaint.sum} SEK</td>
                              <td>{complaint.date}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="form-container">
                      <div data-aid="108080">
                        <!--ORSAK-->
                        <div class="second">
                          <div class="form-group">
                            <label>Orsak</label>
                            <div>
                              <select name="ORSK">
                                <option value="" selected="selected">
                                  -- Välj alternativ --
                                </option>
                                <option value="C">
                                  Fel plock (från vårt lager)
                                </option>
                                <option value="E">Produktreklamation</option>
                                <option value="F">
                                  Retur / Felbeställt / Felregistrering
                                </option>
                                <option value="H">
                                  Transportskada / Saknat gods
                                </option>
                              </select>
                              <div>
                                <div class="mb-sm">
                                  <span
                                    class="fcond article-inbound label label-default"
                                  >Observera 20% returavdrag</span>
                                </div>
                                <div>
                                  <label>Antal i retur:</label>
                                  <div>
                                    <input
                                      type="number"
                                      name="F_KVA"
                                      id="F_KVA"
                                      size="7"
                                      value=""
                                      maxlength="7"
                                      class="form-control"
                                      min="0"
                                      placeholder="Hur många artiklar omfattas av returen"
                                    />
                                  </div>
                                </div>
                                <div class="clear"></div>
                                <label>Övrig information</label>
                                <textarea
                                  maxlength="500"
                                  rows="5"
                                  name="ANM"
                                  class="form-control"
                                  placeholder="Din text"
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                  <tfoot>
                    <button
                      onclick="forward()"
                      type="button"
                      class="button btn btn-primary"
                    ><span>Nästa</span></button>
                  </tfoot>
                </div>
              </div>
            </div>
            <!--padd -->
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-3 sidebar-secondary"></div>
    </div>
  </div>
</div>

<Footer />
<Modals />
